import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import userReducer from "./modules/userData";
import urlReducer from "./modules/firebaseimg";
import itemdataReducer from "./modules/itemdata";
import authReducer from "./slices/authSlice";
import { apiSlice } from "../features/api/apiSlice";
import { adsApiSlice } from "../features/ads/adsApiSlice";
import {
  persistReducer,
  persistStore,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";

const persistConfigUser = { key: "user", version: 1, storage };
const persistConfigUrl = { key: "imgurl", version: 1, storage };
const persistConfigItemdata = { key: "itemdata", version: 1, storage };
const persistConfigAuth = { key: "auth", version: 1, storage };

const persistedReducer = persistReducer(persistConfigUser, userReducer);
const persistedReducertwo = persistReducer(persistConfigUrl, urlReducer);
const persistedReducerthree = persistReducer(
  persistConfigItemdata,
  itemdataReducer,
);
const persistedAuthReducer = persistReducer(persistConfigAuth, authReducer);

export const store = configureStore({
  reducer: {
    user: persistedReducer,
    imgurl: persistedReducertwo,
    itemdata: persistedReducerthree,
    auth: persistedAuthReducer,
    [apiSlice.reducerPath]: apiSlice.reducer,
    [adsApiSlice.reducerPath]: adsApiSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat(apiSlice.middleware, adsApiSlice.middleware),
});

setupListeners(store.dispatch);

let persistor = persistStore(store);
export { persistor };
